import qs from 'qs'

/** { filters: { min: 1, age: 2, distillery: 'rosebank' }} */
const getQueryStringForFilters = (filters) =>
  qs.stringify(filters, { arrayFormat: 'brackets' })

export { getQueryStringForFilters }
